import React from "react";

export default function Arrow() {
  return (
    <svg viewBox="0 0 33 33">
      <path
        d="M3.643 32.634.02 29.011l23.51-23.59-20.37.08V.51h26.328l2.576 2.576v26.328h-5.233V9.366L3.643 32.634Z"
        fill="currentColor"
      />
    </svg>
  );
}
